<template>
    <div class="field is-horizontal adv-search-btns">

        <div class="field-body">
            <div class="field">
                <div class="control">
                    <button class="button is-danger is-fullwidth" :class="{ 'is-loading' : isLoading }" @click="submitForm">
                        Search
                    </button>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <button class="button is-fullwidth" :class="{ 'is-loading' : isLoading }" @click="clearForm">
                        Clear
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            isLoading() {
                return this.$store.getters.getSearchResultsLoadingStatus
            }
        },
        methods: {
            submitForm() {
                if (this.$store.getters.getStatsStatus) {
                    this.$store.dispatch('setSearchQueryPageNumber', 1)
                    this.$store.dispatch('setStatsQueryFieldValue', {field: 'limit_start', value: 0})
                    this.$store.dispatch('setStatsQueryFieldValue', {field: 'limit_end', value: 30})
                    this.$store.dispatch('mergeStatsQueryWithSearch', this.$store.getters.getQuery)
                    this.$store.dispatch('fetchStatsResult')
                } else {
                    this.$store.dispatch('setResultOrderColumn', 'lot_date')
                    this.$store.dispatch('setSearchQueryPageNumber', 1)
                    this.$store.dispatch('fetchResults')
                }
                if (document.documentElement.clientWidth < 450) {
                    document.getElementById('table').scrollIntoView()
                }
            },
            clearForm() {
                this.$store.dispatch('setQueryToDefault')
                this.$store.dispatch('setModelsToDefault')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/Search.vue